



















import Vue from 'vue'
// @ts-ignore
import { DATA } from '../db.ts'

export default Vue.extend({
    name: 'Contents',
    data () {
        return { articles: DATA.articles }
    }
})
